import React from 'react';
import {useSelector} from "react-redux";
import BBDataTable from "../../tables/BBDataTable";
// import Tooltip from "@material-ui/core/Tooltip";
import {BRCustomizedTooltip as Tooltip} from "../../accents/BRCustomizedTooltip";
import {renderCellExpand} from "../../tables/DataGridRenderCellExpand";
import BBIconPaperClipThin from "../../../../assets/bbCustomIcons/BBIconPaperClipThin";
import BBIconHyperlink from "../../../../assets/bbCustomIcons/BBIconHyperlinkRound";
import UpdateSenderNameWidget from "./UpdateSocialTemplateComponentsForTable/UpdateSenderNameWidget";
import UpdateSocialThemeWidget from "./UpdateSocialTemplateComponentsForTable/UpdateSocialThemeWidget";
import UpdateSubjectStringWidget from "./UpdateSocialTemplateComponentsForTable/UpdateSubjectStringWidget";
import AddNewSocialTemplate from "./AddNewSocialTemplate";
import UpdateSocialAccountWidget from "./UpdateSocialTemplateComponentsForTable/UpdateSocialAccountWidget";
import UpdateTestStatusWidget from "./UpdateSocialTemplateComponentsForTable/UpdateTestStatusWidget";
import UpdateVectorTagWidget from "./UpdateSocialTemplateComponentsForTable/UpdateVectorTagWidget";
import UpdateTechTag from "./UpdateSocialTemplateComponentsForTable/UpdateTechTag";
import UpdateTemplateProviderTag from "./UpdateSocialTemplateComponentsForTable/UpdateTemplateProviderTag";
import UpdateTemplateMessages from "./UpdateSocialTemplateComponentsForTable/UpdateTemplateMessages";
import SendTestPhishingTemplate from "./SendTestPhishingTemplate";
import BBIconSendBold from "../../../../assets/bbCustomIcons/BBIconSendBold";

const CurrentSocialTestTemplatesTable = ({props})=>{

    const {templates, loadingTemplates, loadingTemplatesError} = useSelector(({admin})=>admin);

    const currentTemplatesArray = templates && templates.templates && Object.values(templates.templates)
        && Object.values(templates.templates).map((template)=>{
            return{
                ...template,
                sendTest: template.id,
            }
        });

    const vectors = templates && templates.vectors;
    const technologies = templates && templates.technologies;
    const hostingProviders = templates && templates.hosting_providers;

    const title = <div className={"tourSocialIdentitiesTable"}>
        Phishing Templates
    </div>;

    const columns=[
        { field: 'sender_name', headerName: 'Sender', hide: false, flex : 1, sortable: true, type: 'string', renderCell: (params) =>
                renderCellExpand(params, (
                    <Tooltip title={``}>
                    <span>
                        <UpdateSenderNameWidget templateId={params.row.id}
                                                currentValue={params.value}/>
                    </span>
                    </Tooltip>))},
        { field: 'subject', headerName: 'Subject', hide: false, flex : 1, sortable: true, type: 'string',
            renderCell: (params) =>
                renderCellExpand(params, (
                    <Tooltip title={``}>
                    <span>
                        <UpdateSubjectStringWidget
                            templateId={params.row.id}
                            currentValue={params.value}
                            />
                    </span>
                    </Tooltip>))},
        { field: 'social_theme_details', headerName: 'Theme', hide: false, flex : 1, sortable: true, type: 'string', renderCell: (params) =>
                renderCellExpand(params, (
                    <Tooltip title={``}>
                    <span>
                        <UpdateSocialThemeWidget templateId={params.row.id}
                                                 currentValue={params.value.Name}/>
                    </span>
                    </Tooltip>))},
        { field: 'plaintext_message', headerName: 'Message', hide: false, flex : 2, sortable: true, type: 'string', renderCell: (params) =>
                renderCellExpand(params, (
                    <Tooltip title={``}>
                    <span>
                        <UpdateTemplateMessages templateId={params.row.id} currentValue={params.value}/>
                    </span>
                    </Tooltip>))},
        { field: 'social_account', headerName: 'Social Account', hide: false, flex : 1, sortable: true, type: 'string', renderCell: (params) =>
                renderCellExpand(params, (
                    <Tooltip title={``}>
                    <span>
                        {params.value
                        && params.value.domain
                        && params.value.domain.domain
                        && params.value.sender_name
                            &&  <UpdateSocialAccountWidget templateId={params.row.id} currentValue={params.value && params.value.sender_name}/>
                        }
                    </span>
                    </Tooltip>))},
        { field: 'status', headerName: 'Status', hide: false, flex : .5, sortable: true, type: 'string', renderCell: (params) =>
                renderCellExpand(params, (
                    <Tooltip title={``}>
                    <span>
                        {params.value && params.value.name && params.value.description
                            ? <Tooltip title={params.value.description}>
                                <span>
                                    <UpdateTestStatusWidget templateId={params.row.id} currentValue={params.value.name}/>
                                </span>
                        </Tooltip> : "---"}
                    </span>
                    </Tooltip>))},
        { field: 'has_payload', headerName: 'Type of Attack', hide: false, sortable: true, type: 'string', flex: .25,
            renderHeader: (params) => <Tooltip title={"Displays Type of Attack Used."}>
                <span>Type</span>
            </Tooltip>,
            renderCell: (params) =>
                renderCellExpand(params, (<>
                        {params.value
                            ? <Tooltip title={`Attack contained a downloadable file.`}>
                                  <span className={"text-center"}>
                                    <BBIconPaperClipThin className={'text-bb-risk-low'}/>
                                      <p className={"m-0 p-0 align-self-center"}><small>Attachment</small></p>
                                  </span>
                            </Tooltip>
                            : <Tooltip title={`Attack contained a clickable link.`}>
                                  <span className={"text-center"}>
                                    <BBIconHyperlink className={'text-bb-risk-low'}/>
                                      <p className={"m-0 p-0 align-self-center"}><small>Link</small></p>
                                  </span>
                            </Tooltip>
                        }
                    </>

                ))},
        { field: 'associated_vector_definition', headerName: "Vector Tag", hide: false, flex: .5, sortable: false, type: "number",
            renderCell: (params) =>
            renderCellExpand(params, (
                <span>
                    <UpdateVectorTagWidget templateId={params.row.id} currentValue={params.value && vectors
                        ? vectors[params.value].name
                        : "None"}/>
                </span>))},
        { field: 'associated_technology_tag', headerName: "Tech Tag", hide: false, flex: .5, sortable: false, type: "number",
            renderCell: (params) =>
                renderCellExpand(params, (
                    <span>
                    <UpdateTechTag templateId={params.row.id} currentValue={params.value && technologies
                        ? technologies[params.value].name
                        : "None"}/>
                </span>))},
        { field: 'associated_hosting_provider_tag', headerName: "Provider Tag", hide: false, flex: .5, sortable: false, type: "number",
            renderCell: (params) =>
                renderCellExpand(params, (
                    <span>
                    <UpdateTemplateProviderTag templateId={params.row.id} currentValue={params.value && hostingProviders
                        ? hostingProviders[params.value].name
                         : "None"}/>
                </span>))},
        { field: 'id', headerName: 'View More', hide: false, flex:.25, sortable: true, type: 'string',
            renderCell: (params) => (<AddNewSocialTemplate templateId={params.value} viewMore/>),
        },
        { field: 'sendTest', headerName: 'Send Test',renderHeader: (params=>
                <Tooltip title={`Send a test email to yourself`}>
                    <span>
                        <BBIconSendBold/>
                    </span>
                </Tooltip>)
            , hide: false, flex:.25, sortable: true, type: 'string',
            renderCell: (params) => (<SendTestPhishingTemplate templateId={params.value}/>),
        },

    ]

    return(
        <div>
            {templates && !loadingTemplates && !loadingTemplatesError ?
            <BBDataTable
                columns={columns}
                rows={currentTemplatesArray}
                title={title}
                loading={false}
                progressValue={100}
                topRightElement={<AddNewSocialTemplate/>}
            />
                :
                <BBDataTable
                columns={columns}
                rows={[]}
                title={title}
                loading = {true}
                progressValue={0}
                bufferValue={15}
                />
            }
        </div>
    )
}

export default CurrentSocialTestTemplatesTable;